import { Link } from "react-router-dom";

export const Logo = ({ testId = "nav-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-3">
    <span className="live-dot" />
    <span className="font-display text-lg font-bold uppercase tracking-[0.12em] text-white transition-colors group-hover:text-[#FF3333]">
      Riot Factory
    </span>
  </Link>
);
